export const API_ROOT = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/oxbo-translation-api/' : '/oxbo-translation-api/';